"use client"

import { GripHorizontal } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `GripHorizontalIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const GripHorizontalIcon = component(Icon)({ as: GripHorizontal })
